export const styleSocialButton = {
    bg: "transparent",
    rounded: "full",
    w: "8",
    h: "8",
    cursor: "pointer",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    transition: "all 0.2s ease-in-out",
    color: "white",
    _hover: {
        bg: "transparent",
        transform: "translateY(-2px)",
        color: "green.400",
        filter: "drop-shadow(0 0 8px rgba(72, 187, 120, 0.5))",
    },
};
